import { Database, Trash2 } from 'lucide-react';
import type { AnalysisResult } from '../domain/models';

type SettingsPageProps = {
  result: AnalysisResult | null;
  storageMessage?: string | null;
  onSave: () => void;
  onDeleteAll: () => void;
};

export function SettingsPage({ result, storageMessage, onSave, onDeleteAll }: SettingsPageProps) {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">IndexedDB への保存はこの画面の操作後のみ行います。</p>
        </div>
      </header>

      <section className="surface" style={{ padding: 18 }}>
        <div className="section">
          <div>
            <h2 className="section-title">Local Storage</h2>
            <p className="section-note">保存先はこのブラウザの IndexedDB です。クラウド保存や共有 URL は作成しません。</p>
          </div>
          <div className="button-row">
            <button className="button primary" type="button" disabled={!result} onClick={onSave}>
              <Database size={16} aria-hidden="true" />
              解析結果を保存
            </button>
            <button className="button danger" type="button" onClick={onDeleteAll}>
              <Trash2 size={16} aria-hidden="true" />
              ローカル保存を削除
            </button>
          </div>
          {storageMessage ? <div className="alert">{storageMessage}</div> : null}
        </div>
      </section>

      <section className="surface" style={{ padding: 18 }}>
        <div className="section">
          <h2 className="section-title">解析パラメータ</h2>
          <div className="metadata-grid">
            <div className="metadata-item">
              <span>最小滞在時間</span>
              <strong>10 分</strong>
            </div>
            <div className="metadata-item">
              <span>最大半径</span>
              <strong>150 m</strong>
            </div>
            <div className="metadata-item">
              <span>ギャップ許容</span>
              <strong>20 分</strong>
            </div>
            <div className="metadata-item">
              <span>異常速度閾値</span>
              <strong>900 km/h</strong>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
